import React from 'react'
import PropTypes from 'prop-types'
import { Transition } from 'semantic-ui-react'
import './fetching-loader.css'


const propTypes = { isFetching: PropTypes.bool }

const defaultProps = { isFetching: false }

const FetchingLoader = (props) => {
  const { isFetching } = props
  return (
    <div className={`frame ${isFetching ? '' : 'hiddenFrame'}`}>
      <Transition visible={isFetching} animation='fade up' duration={500}>
        <div className="center">
          <div className="dot1" />
        </div>
      </Transition>
    </div>
  )
}

FetchingLoader.propTypes = propTypes
FetchingLoader.defaultProps = defaultProps

export default FetchingLoader
